import React, { useState, useEffect, useRef, useCallback } from 'react';
import './TopBar.css';
import logo from '../assets/topBarBitLifeLogo.png';

//import homeIcon from '../assets/topBarHome.png';
import shopIcon from '../assets/topBarShop.png';

//import homeIconYellow from '../assets/topBarHomeYellow.png';
import shopIconYellow from '../assets/topBarShopYellow.png';

import topbarBg from '../assets/topBarBackground.png';
import loginMenu from '../assets/topBarLoginRectangle.png';

import { trackEvent } from '../utils/Analytics';

function isMobile() {
    return window.innerWidth <= 768;
}

function TopBar({onNavigate, onLoginClick, currentView, showLoginButton, showStoreButton, onVisibilityChange,shouldBlockScroll}) {
    // Import necessary hooks
    // State to control the animation
    const [isAnimating, setIsAnimating] = useState(false);
    const [animationType, setAnimationType] = useState('wiggle'); // State for animation type
    const [visible, setVisible] = useState(true);
    const lastScrollY = useRef(window.scrollY);
    const animationIndex = useRef(0);
   // let lastScrollIframeY = useRef(null);

    useEffect(() => {
        const animations = ['pulse','wiggle', 'bounceupanddown', 'bouncesidetoside']; //'pulse','point-and-shake','wiggle', 'bounceupanddown', 'bouncesidetoside'
        const triggerAnimation = () => {
           // const chosenAnimation = animations[Math.floor(Math.random() * animations.length)];
            const chosenAnimation = animations[animationIndex.current];
            setAnimationType(chosenAnimation);
            setIsAnimating(true); // Start the animation

            // Move to the next animation, looping back to the start
            animationIndex.current = (animationIndex.current + 1) % animations.length;

            // Stop the animation after 1.2 seconds
            setTimeout(() => {
                setIsAnimating(false);
            }, 2400); // Duration of the wiggle animation
        };

        // Trigger the animation immediately on component load
        triggerAnimation();

        // Set an interval to run the animation every 2 seconds thereafter
        const interval = setInterval(triggerAnimation, 4800);

        // Clean up the interval when the component is unmounted
        return () => clearInterval(interval);
    }, []);

    const handleScroll = useCallback((currentScrollY, lastScroll, currentView) => {
        if (!isMobile() || currentView !== 'store' || showLoginButton || shouldBlockScroll) {
            return;
        }
        if (currentScrollY <= 40) {
            setVisible(true);
            onVisibilityChange(true);
        } else if (currentScrollY > lastScroll.current) {
            setVisible(false); // scrolling down
            onVisibilityChange(false);
        } else {
            setVisible(true); // scrolling up
            onVisibilityChange(true);
        }
        lastScroll.current = currentScrollY;
    },[ showLoginButton, onVisibilityChange, shouldBlockScroll]);
    
    useEffect(() => {
        const handleIframeScroll = () => {
            handleScroll(window.scrollY, lastScrollY,currentView);
        }
        window.addEventListener('scroll', handleIframeScroll);
        return () => window.removeEventListener('scroll', handleIframeScroll);
    }, [currentView,onVisibilityChange, showLoginButton, handleScroll]);

    useEffect( () => {
        if (!isMobile() || currentView !== 'store') {
            setVisible(true); // scrolling up
            onVisibilityChange(true);
            return;
        }
    },[currentView,onVisibilityChange]);

    
    return (
        <header className={`fixed-header${visible ? '' : ' hidden'}${!showLoginButton ? ' no-login' : ''}${!showStoreButton ? ' no-store' : ''}`} style={{
            backgroundImage: `url(${topbarBg})`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
        }}>

            {showLoginButton && <div className="header-row">
                <div className="login-section">
                        <div className="login-section__overlay-container">
                            <img src={loginMenu} alt="Login Options" className="login-section__image"/>
                            <button
                                className="login-section__button login-section__button--left"
                                onClick={() => {
                                    trackEvent('login_button_click', 'engagement', 'Login Button');
                                    onLoginClick(); // make sure this is a function
                                }}
                            >
                                {'Log in'}
                            </button>
                        </div>
                    </div>
            </div>}

            <div className="header-row">
                    <div className="left-container">
                        <button
                            onClick={() => {
                                trackEvent('navigate_home', 'navigation', 'Home Tab');
                                if(showStoreButton) {
                                    onNavigate('homepage');
                                }
                            }}
                            className="nav-button"
                        >
                            <img src={logo} alt="BitLife Logo" className="logo"/>
                        </button>
                        
                    </div>
                { showStoreButton && <div className={`nav-container ${currentView !== 'store' && isAnimating ? animationType: ''}`}>
                        <button
                            onClick={() => {
                                trackEvent('navigate_shop', 'navigation', 'Shop Tab');
                                onNavigate('store');
                            }}
                            className="nav-button"
                        >
                            <img
                                src={currentView === 'store' ? shopIconYellow : shopIcon}
                                alt="Shop"
                                className={`icon ${currentView === 'store' ? 'active' : ''}`}
                            />
                            <span
                                className={`nav-label ${currentView === 'store' ? 'active' : ''}`}> {'Store'} </span>
                        </button>
                    </div>}
            </div>
        </header>
);
}

export default TopBar;
